import { render, staticRenderFns } from "./Errorpath.vue?vue&type=template&id=9a205ea4&scoped=true&"
import script from "./Errorpath.vue?vue&type=script&lang=js&"
export * from "./Errorpath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a205ea4",
  null
  
)

export default component.exports